module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"generateApiKeyCard.title":"Create new API key","generateApiKeyCard.subtitle":"This new api-key will only be made visible once. Make sure you keep a copy before continuing.","generateApiKeyCard.ApiKey":"API-Key","generateApiKeyCard.ApiKey.placeholder":"Click generate to make a new API key"}}')
  delete Component.options._Ctor
}
